export default __webpack_public_path__ + "static/media/factory_icon_selected.c1fcac90.svg";